import getScript from './getScript'
import Deferred from './deferred'
import { getMarketCode } from './dataLayer'

function initYouTubeIframeAPI() {
    const deferred = new Deferred()

    if (window.YT?.Player || getMarketCode() === 'cn') {
        deferred.resolve()
    }

    // YouTube API will call this function automatically when player API is ready
    // https://developers.google.com/youtube/iframe_api_reference
    window.onYouTubeIframeAPIReady = function () {
        deferred.resolve()
    }

    getScript('https://www.youtube.com/iframe_api', false).then(() => {
        window.YT?.ready(() => deferred.resolve())
    })

    return deferred.promise
}

class PlayerYoutube {
    constructor() {
        this.iframeApi = initYouTubeIframeAPI()
    }

    attach(iframeContainer, videoId, isBackgroundVideoPlaying, isAutoPlay = 1, moreParams = {}) {
        let params = {}

        if (isBackgroundVideoPlaying) {
            params = { playlist: videoId, controls: 0, loop: 1 }
        }

        return new Promise(resolve => {
            this.iframeApi.then(() => {
                const player = new window.YT.Player(iframeContainer, {
                    videoId,
                    host: 'https://www.youtube-nocookie.com',
                    playerVars: {
                        // disablekb: 1,
                        // showinfo: 0,
                        // modestbranding: 1,
                        enablejsapi: 1,
                        rel: 0,
                        fs: 0,
                        autoplay: isAutoPlay,
                        ...params,
                        ...moreParams
                    },
                    events: {
                        onReady: () => {
                            if (isBackgroundVideoPlaying) {
                                player.mute()
                            }
                            resolve(player)
                        },
                        onStateChange: () => ({}),
                        onError: () => ({})
                    }
                })
            })
        })
    }
}

export default PlayerYoutube
